import { render, staticRenderFns } from "./ReportFilters.vue?vue&type=template&id=3b4f9870&"
import script from "./ReportFilters.vue?vue&type=script&lang=js&"
export * from "./ReportFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports